export default "__VITE_ASSET__DIgA041N__"